import { cn } from "@/lib/utils";
import { ChatEntry, Suggestion } from "@/types/chat";
import { Send } from "lucide-react";

type ChatQuickAnswersProps = {
  suggestions: Suggestion[];
  onSelectSuggestion: (suggestion: Suggestion) => void;
  chatEntry: ChatEntry;
  className?: string;
};

export const ChatQuickAnswers = (props: ChatQuickAnswersProps) => {
  const { suggestions, onSelectSuggestion, chatEntry, className } = props;

  return (
    <div className="flex flex-col gap-1 px-4 md:px-8 pt-2 pb-3 border-t border-t-gray-200">
      <label className="text-xs text-gray-400">Quick Answers:</label>

      <div className="flex flex-wrap gap-x-2 gap-y-2 w-full ">
        {suggestions.map((suggestion) => (
          <button
            type="button"
            key={suggestion.id}
            className={cn(
              "flex items-center gap-2 rounded-lg text-white text-xs font-medium p-2 px-4 transition-all bg-bodhi-teal/90 hover:bg-bodhi-teal"
            )}
            onClick={() => onSelectSuggestion(suggestion)}
          >
            {suggestion.label}
            <Send size={12} />
          </button>
        ))}
      </div>
    </div>
  );
};
